import React, { Component } from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import {
  APARTMENT_LOCATOR_LEASE_SIGN_PERCENTAGE_THRESHOLD_RED,
  APARTMENT_LOCATOR_LEASE_SIGN_PERCENTAGE_THRESHOLD_YELLOW,
} from 'common/apartmentLocatorHelpers';
import SrMonthlyFlicker from 'client/components/SrMonthlyFlicker';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import branch from 'client/core/branch';
import ApartmentLocatorActions from 'client/actions/ApartmentLocator';
import SrCardContainer from 'client/components/SrCardContainer';

@branch({
  currentUser: ['currentUser'],
  stats: ['apartmentLocator', 'monthToDateStats'],
})
class SrApartmentLocatorStats extends Component {
  static propTypes = {
    stats: PropTypes.object,
  };

  constructor() {
    super();

    this.state = {
      startDate: momentWithAustinTimezone().startOf('month'),
      endDate: momentWithAustinTimezone().endOf('month'),
    };
  }

  _onMonthUpdated = (startDate, endDate) => {
    const { dispatch, currentUser } = this.props;

    const currentMonthDateRange = [startDate, endDate];

    this.setState({
      startDate: momentWithAustinTimezone(startDate),
      endDate: momentWithAustinTimezone(endDate),
    });

    dispatch(ApartmentLocatorActions.getCurrentMonthLeaseStats, {
      apartmentLocatorUserId: currentUser.id,
      currentMonthDateRange,
    });
  };

  componentDidMount() {
    const { dispatch, currentUser } = this.props;
    const { startDate, endDate } = this.state;

    const currentMonthDateRange = [startDate.toISOString(), endDate.toISOString()];

    dispatch(ApartmentLocatorActions.getCurrentMonthLeaseStats, {
      apartmentLocatorUserId: currentUser.id,
      currentMonthDateRange,
    });
  }

  render() {
    const { stats } = this.props;

    if (!stats) {
      return null;
    }

    const leaseSignRatePercentage = (stats.leaseSignRate * 100).toFixed(2);
    const leaseSignRateColor =
      leaseSignRatePercentage < APARTMENT_LOCATOR_LEASE_SIGN_PERCENTAGE_THRESHOLD_RED
        ? 'red'
        : leaseSignRatePercentage < APARTMENT_LOCATOR_LEASE_SIGN_PERCENTAGE_THRESHOLD_YELLOW
        ? 'yellow'
        : 'green';

    return (
      <SrCardContainer>
        <SrMonthlyFlicker
          title="lease rate"
          type="small"
          onMonthUpdated={(startDate, endDate) => this._onMonthUpdated(startDate, endDate)}
        />
        <div className="SrApartmentLocatorStats">
          <div className={`leaseSignRate ${leaseSignRateColor}`}>
            <span className="leaseSignRatePercentage">{leaseSignRatePercentage}</span>
            <span className="leaseSignRateDecoration">%</span>
          </div>
          <div className="leaseSignRatio">
            <span>
              {`${stats.signedLeadCount} ${pluralize('lease', stats.signedLeadCount)} signed ` +
                `/ ${stats.leadCount} ${pluralize('lead', stats.leadCount)}`}
            </span>
          </div>
        </div>
      </SrCardContainer>
    );
  }
}

SrApartmentLocatorStats.displayName = 'SrApartmentLocatorStats';

export default SrApartmentLocatorStats;
